import { get, post, remove } from "./api";

export const getTemplates = async (): Promise<any> => {
  const { data = [] } = await get({ path: `/templates` });
  return data;
};

export const getAttributes = async (contexts: string[]): Promise<any> => {
  const { data = [] } = await get({
    path: `/templates/attributes?contexts=${contexts.join(",")}`,
  });
  return data;
};

export const getTemplate = async (templateId: string): Promise<any> => {
  const { data = {} } = await get({ path: `/templates/${templateId}` });
  return data;
};

export const saveTemplate = async (formData): Promise<any> => {
  const { data = {} } = await post({ path: `/templates`, data: formData });
  return data;
};

export const deleteTemplate = async (templateId): Promise<void> => {
  await remove({ path: `/templates/${templateId}` });
};
